import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Newsletter from "@/pages/Newsletter";

export const Route = createFileRoute("/zh-cn/newsletter")({
  head: () => buildRouteHead("/zh-cn/newsletter"),
  component: Newsletter,
});

